<template>
    <Modal :open="open" :removePadding="true" :narrow="false" :show-close-icon="true" @close="closeModal" :close-has-background="true">
    <div class="cms-content-find-dealer__opening-times--modal">
        <div
            v-for="(schedule, type) in openingTimes"
            :key="type"
            class="cms-content-find-dealer__opening-times--type"
        >
            <strong class="cms-content-find-dealer__opening-times--type--title">{{ capitalise(type) }}</strong>
            <div class="cms-content-find-dealer__opening-times--list">
            <template v-for="(hours, date) in schedule">
                <div :key="date" class="cms-content-find-dealer__opening-times--day">{{ date }}:</div>
                <div :key="date" class="cms-content-find-dealer__opening-times--time"><strong>{{ hours }}</strong></div>
            </template>
            </div>
        </div>
      </div>
    </Modal>
</template>

<script>
import Modal from "../../../../core/components/Modal.vue";

export default {
    components: {
        Modal,
    },
    
    props: {
        open: {
            default: false,
        },
        openingTimes: {
            
        }
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        closeModal() {
            this.$emit("close-modal");
        },
        capitalise(str) { return str.charAt(0).toUpperCase() + str.slice(1) },
    },
};
</script>

